import {
    FETCHED_POPUP_DATA,
    UPDATE_SECTION_TITLE,
    UPDATE_SECTION_SETTING,
    UPDATE_ITEM_TEXT,
    UPDATE_ITEM_IMAGE,
    UPDATE_ITEM_IMAGE_CROP,
    UPDATE_ITEM_IMAGE_CROP_RATIO,
    UPDATE_ITEM_IMAGE_CROP_THUMB,
    UPDATE_ITEM_IMAGE_META,
    DELETE_ITEM_IMAGE,
} from '../types/text_columns_multiple_media';

export function fetchedPopupData(pageId, sectionId, sectionToEdit) {
    return {
        type: FETCHED_POPUP_DATA,
        payload: {
            pageId,
            sectionId,
            sectionToEdit,
        },
    };
}

export function updateSectionTitle(title) {
    return {
        type: UPDATE_SECTION_TITLE,
        payload: title,
    };
}

export function updateItemText(index, text) {
    return {
        type: UPDATE_ITEM_TEXT,
        payload: {
            index,
            text,
        },
    };
}

export function updateItemImage(index, image) {
    return {
        type: UPDATE_ITEM_IMAGE,
        payload: {
            index,
            image,
        },
    };
}

export function updateSectionSetting(selectedOptions, forSetting) {
    selectedOptions =
        selectedOptions !== undefined && selectedOptions instanceof Array
            ? selectedOptions
            : [selectedOptions];

    return {
        type: UPDATE_SECTION_SETTING,
        payload: {
            selectedOptions,
            forSetting,
        },
    };
}

export function updateItemImageCrop(
    index,
    image,
    imageUrlBlob,
    imageBlobObject
) {
    return {
        type: UPDATE_ITEM_IMAGE_CROP,
        payload: {
            index,
            image,
            imageUrlBlob,
            imageBlobObject,
        },
    };
}

export function updateItemImageCropThumb(
    index,
    image,
    imageUrlBlob,
    imageBlobObject
) {
    return {
        type: UPDATE_ITEM_IMAGE_CROP_THUMB,
        payload: {
            index,
            image,
            imageUrlBlob,
            imageBlobObject,
        },
    };
}

export function updateItemImageCropRatio(index, cropRatioId) {
    return {
        type: UPDATE_ITEM_IMAGE_CROP_RATIO,
        payload: {
            index,
            cropRatioId,
        },
    };
}

export function updateItemImageMeta(index, meta) {
    const {title, alt, link, name, filename, description} = meta;
    const imageMeta = {
        title,
        alt,
        name:
            name !== undefined ? name : filename !== undefined ? filename : '',
        description,
        link,
    };

    return {
        type: UPDATE_ITEM_IMAGE_META,
        payload: {
            index,
            imageMeta,
        },
    };
}

export function deleteItemImage(index, image) {
    return {
        type: DELETE_ITEM_IMAGE,
        payload: {
            index,
            image,
        },
    };
}



// WEBPACK FOOTER //
// ./src/containers/builder/sections/actions/text_columns_multiple_media.js